import RecipesList from './recipes-list';
import ListAsyncManager, {AsyncListManagerEvent} from "../../../helpers/asyncListManager/AsyncListManager";

export default class RecipesListMobile extends RecipesList {
    constructor(...args) {
        super(...args);

        this._action = "candiapro_recipes_posts_ajax";
        this._retrieveDOM();
    }


    _retrieveDOM() {
        super._retrieveDOM();
        //this.dom.views.wall = this._find('.js-wall');

        this.dom.load_more = this.dom.page.querySelector('.js-load-more');
        this.dom.results = this.dom.page.querySelector('.js-recipe-list');

        this._ALM = new ListAsyncManager(this._action, this.dom.load_more);
        this._locked = false;
    }

    bind() {
        super.bind();

        // Load More
        if(this.dom.load_more) {
            this.dom.load_more.addEventListener('click', (e) => {
                if( this._locked == false ) {
                    this._locked = true;
                    let copyParamsRecipes = Object.assign({}, this._PopinFilter._paramsRecipes);
                    this._ALM.setOpts(copyParamsRecipes);
                    this._ALM.loadMore(e);
                }
            });
        }

        // Data receive
        this._ALM.on(AsyncListManagerEvent.UPDATED, (xhr) => {
            this._injectData(xhr);
        });
    }

    _injectData(xhr) {
        this._locked = false;
        console.log(xhr.data);
        // Check if there is result
        if(xhr.data.has_results == false) {
            this.hideLoadMore();
        } else {

            // Check if there is other data to load
            if(xhr.data.load_more == true)
                this.showLoadMore();
            else
                this.hideLoadMore();

            if(xhr.data.page == 1) {
                this.dom.results.innerHTML = xhr.data.recipes_html;
            } else {
                this.dom.results.insertAdjacentHTML('beforeend', xhr.data.recipes_html);
            }

            this.recipeItems = document.querySelectorAll('.to-animate');
            for(var i = 0, j = this.recipeItems.length; i < j; i++)
            {
                var delay = i * 110;
                this._animateResult(i, delay);
            }
        }

    }

    hideLoadMore() {
        if( this.dom.load_more )
            this.dom.load_more.classList.add('hidden');
    }

    showLoadMore() {
        if( this.dom.load_more )
            this.dom.load_more.classList.remove('hidden');
    }

    _animateResult(index, delay) {
        setTimeout(() => {
            this.recipeItems[index].classList.remove('to-animate');
        }, delay);
    }
    
}



// WEBPACK FOOTER //
// ./src/js/pages/recipes/list/recipes-list.mobile.js